import r from "../managers/braze-instance.js";
import tr from "./feature-flags-provider-factory.js";
export function getFeatureFlag(t) {
  if (!r.rr()) return;
  const e = r.v();
  if (e && !e.ke()) return null;
  const n = tr.m().Me();
  return n[t] ? n[t] : null;
}
